/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Inboxes extends CacheEnabledApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'inbox';
  }

  getCampaigns(inboxId) {
    return axios.get(`${this.url}/${inboxId}/campaigns`);
  }

  deleteInboxAvatar(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/avatar`);
  }

  getAgentBot(inboxId) {
    return axios.get(`${this.url}/${inboxId}/agent_bot`);
  }

  setAgentBot(inboxId, botId) {
    return axios.post(`${this.url}/${inboxId}/set_agent_bot`, {
      agent_bot: botId,
    });
  }

  syncTemplates(inboxId) {
    return axios.post(`${this.url}/${inboxId}/sync_templates`);
  }

  createInternalTemplate(inboxId, payload) {
    return axios.post(`${this.url}/${inboxId}/internal_template`, payload);
  }

  uploadInternalTemplateImage(inboxId, file) {
    const formData = new FormData();
    formData.append('file', file, file?.name || 'internal-template-image');
    return axios.post(
      `${this.url}/${inboxId}/internal_template_image_upload`,
      formData
    );
  }

  deleteInternalTemplate(inboxId, templateId) {
    return axios.delete(`${this.url}/${inboxId}/internal_template`, {
      data: { template_id: templateId },
    });
  }

  refreshLineToken(inboxId) {
    return axios.post(`${this.url}/${inboxId}/refresh_line_token`);
  }

  greenApiStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/green_api_status`);
  }

  greenApiReconnect(inboxId) {
    return axios.post(`${this.url}/${inboxId}/green_api_reconnect`);
  }

  getEyeCatcherGallery(inboxId) {
    return axios.get(`${this.url}/${inboxId}/eye_catcher_gallery`);
  }

  deleteEyeCatcherGalleryItem(inboxId, payload) {
    const filename =
      typeof payload === 'string' ? payload : payload?.filename || '';
    const attachmentId =
      typeof payload === 'object' ? payload?.attachment_id : undefined;
    return axios.delete(`${this.url}/${inboxId}/eye_catcher_gallery_item`, {
      data: {
        filename,
        ...(attachmentId ? { attachment_id: attachmentId } : {}),
      },
    });
  }

  uploadEyeCatcher(inboxId, file) {
    const formData = new FormData();
    formData.append('file', file, file?.name || 'eye-catcher');
    return axios.post(`${this.url}/${inboxId}/eye_catcher_upload`, formData);
  }

  uploadBubbleIcon(inboxId, file) {
    const formData = new FormData();
    formData.append('file', file, file?.name || 'bubble-icon');
    return axios.post(`${this.url}/${inboxId}/bubble_icon_upload`, formData);
  }

  uploadWelcomeHeaderLogo(inboxId, file) {
    const formData = new FormData();
    formData.append('file', file, file?.name || 'welcome-header-logo');
    return axios.post(
      `${this.url}/${inboxId}/welcome_header_logo_upload`,
      formData
    );
  }

  uploadPreChatHeaderImage(inboxId, file) {
    const formData = new FormData();
    formData.append('file', file, file?.name || 'pre-chat-header-image');
    return axios.post(
      `${this.url}/${inboxId}/pre_chat_header_image_upload`,
      formData
    );
  }

  uploadPoweredByIcon(inboxId, file) {
    const formData = new FormData();
    formData.append('file', file, file?.name || 'powered-by-icon');
    return axios.post(
      `${this.url}/${inboxId}/powered_by_icon_upload`,
      formData
    );
  }

  // Inbox Archive (Phase 1B). The archive call is gated by the
  // `inbox_archive` feature flag on the backend; the UI should also check
  // the flag before showing entry points so users on accounts without the
  // flag see the original delete-only flow.
  archiveInbox(inboxId, { reason } = {}) {
    return axios.post(`${this.url}/${inboxId}/archive`, {
      archive: { reason },
    });
  }

  unarchiveInbox(inboxId) {
    return axios.post(`${this.url}/${inboxId}/unarchive`);
  }

  permanentDeleteInbox(inboxId) {
    return axios.delete(`${this.url}/${inboxId}`, {
      params: { permanent: true },
    });
  }
}

export default new Inboxes();
